module.exports = __webpack_public_path__ + "static/media/car-basic.f1598101.svg";